import { format } from 'date-fns';

export const formatDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : format(date, 'MM/dd/yyyy HH:mm');
};

export const formatMoney = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4 })
    : '—';
};

export const formatQty = (value) => (value === null || value === undefined || value === '' ? '—' : Number(value).toLocaleString('en-US'));

export const apiError = (error, fallback) => error?.response?.data?.error || error?.message || fallback;

// Same long-form date as the Purchase Orders list.
export const formatLongDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};
